import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { MainProductType, Product } from '../../interfaces';
import './shoppingCartInstallmentsInterest.less';

interface Props {
  product: Product;
}

const ShoppingCartInstallmentsInterest: React.FC<Props> = ({ product }) => {
  const { shoppingCartTranslations: t, paymentForm: paymentForm_t } =
    useSelector((data: RootState) => data.config.translations);

  return (
    <div className="installments-interest-card">
      <div className="installments-interest-card__rows">
        <div className="installments-interest-card__row">
          <span className="installments-interest-card__label">
            <span>{paymentForm_t.creditCardInterest}:</span>
            <span>
              {product?.product_data?.payments_num} {paymentForm_t.payments} -{' '}
              {product?.product_data?.interestsPrecent}%{' '}
              {paymentForm_t.interest}
            </span>
            <span>
              {paymentForm_t.card}: XXXX-XXXX-{product?.product_data?.card_info?.digits}
            </span>
          </span>
          <span className="installments-interest-card__value">
            {product?.product_data?.interestsAmount} {product?.base_currency_sign}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCartInstallmentsInterest;
